// Game constants - kept separate to avoid circular imports
export const GAME_WIDTH = 640;
export const GAME_HEIGHT = 480;
export const TILE_SIZE = 16;
